import { useState, useEffect } from 'react';
import { MapPin, Search, X, ChevronRight } from 'lucide-react';
import api from '../lib/api';
import { useCidade } from '../context/CidadeContext';

export function SeletorCidade({ onClose }) {
  const { setCidade } = useCidade();
  const [cidades, setCidades] = useState([]);
  const [busca, setBusca] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/cidades')
      .then(res => setCidades(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const filtered = cidades.filter(c =>
    c.nome.toLowerCase().includes(busca.toLowerCase()) ||
    c.uf.toLowerCase().includes(busca.toLowerCase()) ||
    c.estado.toLowerCase().includes(busca.toLowerCase())
  );

  const handleSelect = (c) => {
    setCidade(c);
    onClose?.();
  };

  const handleAll = () => {
    setCidade(null);
    onClose?.();
  };

  return (
    <div
      className="fixed inset-0 z-50 bg-black/50 flex items-end sm:items-center justify-center p-0 sm:p-4"
      onClick={(e) => e.target === e.currentTarget && onClose?.()}
    >
      <div className="bg-white rounded-t-2xl sm:rounded-2xl w-full sm:max-w-sm max-h-[80vh] flex flex-col shadow-2xl">
        <div className="p-5 border-b border-gray-100">
          <div className="flex items-center justify-between mb-4">
            <h2 className="font-semibold text-gray-900 text-lg" style={{ fontFamily: "'Work Sans', sans-serif" }}>
              Sua cidade
            </h2>
            {onClose && (
              <button
                onClick={onClose}
                className="p-1.5 hover:bg-gray-100 rounded-lg transition-colors"
                data-testid="close-seletor"
              >
                <X size={18} className="text-gray-500" />
              </button>
            )}
          </div>
          <div className="relative">
            <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              value={busca}
              onChange={e => setBusca(e.target.value)}
              placeholder="Buscar cidade..."
              className="w-full border border-gray-200 rounded-xl px-3 py-2.5 pl-9 text-sm focus:outline-none focus:ring-2 focus:ring-[#1D9E75] focus:border-transparent"
              autoFocus
              data-testid="busca-cidade-input"
            />
          </div>
        </div>

        <div className="overflow-y-auto flex-1 p-2">
          <button
            onClick={handleAll}
            className="w-full flex items-center gap-3 px-3 py-3 hover:bg-[#E1F5EE] rounded-xl transition-colors text-left"
            data-testid="todas-cidades-btn"
          >
            <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <MapPin size={15} className="text-gray-400" />
            </div>
            <span className="text-sm font-medium text-gray-700 flex-1">Todas as cidades</span>
            <ChevronRight size={15} className="text-gray-300" />
          </button>

          {loading ? (
            <div className="py-8 text-center text-gray-400 text-sm">Carregando...</div>
          ) : (
            filtered.map(c => (
              <button
                key={c.id}
                onClick={() => handleSelect(c)}
                className="w-full flex items-center gap-3 px-3 py-3 hover:bg-[#E1F5EE] rounded-xl transition-colors text-left"
                data-testid={`cidade-${c.uf.toLowerCase()}`}
              >
                <div className="w-8 h-8 bg-[#E1F5EE] rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-[#1D9E75] font-bold text-xs">{c.uf}</span>
                </div>
                <div className="flex-1">
                  <p className="text-sm font-medium text-gray-900">{c.nome}</p>
                  <p className="text-xs text-gray-500">{c.estado}</p>
                </div>
                <ChevronRight size={15} className="text-gray-300" />
              </button>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
